import BaseService from '@root/core/class/BaseService';

class forwardingService extends BaseService {
  public getMessageList = (
    page: number,
    search: string,
    fromDt?: string,
    endDt?: string
  ) => {
    return this.get(
      `/forwardings/posts?page=${page}&limit=10&search=${search}&searchBy=forwarding.name${
        fromDt ? `&fromDt=${fromDt}` : ''
      }${endDt ? `&endDt=${endDt}` : ''}`
    );
  };

  public createForwardingMessage = (data: {
    quotationId?: number;
    postId: number;
    content: string;
    attachment: string[];
  }) => {
    return this.post('/forwardings/posts/dialogs', data);
  };

  public getMessageDetail = (id: number) => {
    return this.get(`/forwardings/posts/detail/${id}`);
  };

  public updateMessage = (
    id: number,
    attachment?: string[],
    content?: string
  ) => {
    return this.put(`/forwardings/posts/dialogs/${id}`, {
      content,
      attachment
    });
  };

  public updateStatus = (
    id: number,
    data: { status?: string; cancelStatus?: string }
  ) => {
    return this.put(`/forwardings/posts/status/${id}`, data);
  };

  public uploadFile = (files: File[]) => {
    const formData = new FormData();
    files.forEach((file) => {
      formData.append('attachments', file);
      console.log('Appending file:', file.name);
    });

    return this.post('/forwardings/upload-file', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }).catch((error) => {
      if (error.response?.status === 413) {
        alert('용량이 너무 큽니다');
      }
      throw error;
    });
  };
}

export default new forwardingService('/api/v1/seller', true);
